import { TRESPONSE_AI_ANALYTICS_QUESTION } from '@monorepo/types';
import { TChatUiModel } from '@monorepo/ui/chat-ui';

export type TAiAnalyticsState = {
  chatUiModel: TChatUiModel<TRESPONSE_AI_ANALYTICS_QUESTION> | null;
  lastSeparatorText: string | null;
};

export const TAiAnalyticsActionType = {
  SetAiAnalyticsChatUiModel: 'SET_AI_ANALYTICS_CHAT_UI_MODEL' as const,
  GetAiAnalyticsChatUiModel: 'GET_AI_ANALYTICS_CHAT_UI_MODEL' as const,
  SetAiAnalyticsLastSeparatorText: 'SET_AI_ANALYTICS_LAST_SEPARATOR_TEXT' as const,
};

export const MAX_QUERIES_ALLOWED_IN_AI_ANALYTICS_CHAT = 50;
export const START_NEW_CONVERSATION_CONFIRMATION_TEXT = {
  LIMIT_REACHED: {
    header: 'Conversation Limit Reached!',
    content: ['To continue, please start a new chat', 'This will clear the current conversation and start a new chat'],
  },
  USER_ACTION: {
    header: 'Start New Chat?',
    content: ['This will clear the current conversation and start a new chat.'],
  },
};

export const AI_ANALYTICS_QUICK_QUESTIONS = [
  'Breakdowns in the past week',
  'Top 5 machines with most downtime',
  'Top 5 spare parts consumed',
  'What is the MTBF for this month?',
  'Date-wise Non-productive Time',
  'Which line had the highest downtime?',
  'Compare downtime by machine breakdown reasons',
  'How many Machine Issue tickets were raised today?',
  'Preventive Maintenance Plan for next month.',
  'What is the PMP for current month?',
];
